import { createAction, props } from '@ngrx/store';

export const sendPaymentLink = createAction('[Orders] Send Payment Link', props<{ orderId: number }>());

export const sendPaymentLinkSuccess = createAction('[Orders] Send Payment Link Success');

export const sendPaymentLinkFailure = createAction('[Orders] Send Payment Link Failure', props<{ error: any }>());
